module.exports = __webpack_public_path__ + "static/img/title-banner1-type2.a8d32a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1/title-banner1-type2.png
// module id = lrXQ
// module chunks = 1